import { GoogleTagManager, tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { fork, put, select, takeLatest } from 'redux-saga/effects';

import { SAVE_EDITED_LOAN_APPLICATION } from './LoanRequestDetails.actions';
import { getUpdatedRequestedProducts } from '../../lendingAPI/helpers/ApplicationAPIHelper';
import { putAPI } from '../../lendingAPI/lendingAPIHelpers';
import { hasAutomatedDecision } from '../../lendingAPI/lendingAPISelector';
import { getAmplitudeDefaultEventProperties } from '../../tracking/amplitudeEvents';
import { CLOSE_MODAL } from '../Modals/Modals.actions';

export default [fork(saveEditedLoanApplication)];

function* saveEditedLoanApplication() {
    yield takeLatest(SAVE_EDITED_LOAN_APPLICATION, function* () {
        const editedApplicationAmount = yield select((state) =>
            _.get(
                state,
                'form.sign_up.loanRequestDetails.loan_request.amount.value'
            )
        );

        const currentApplicationData = yield select(
            (state) => state.lendingAPI?.application?.data
        );

        let requestedProducts;

        if (!currentApplicationData) {
            requestedProducts = [
                {
                    amount: editedApplicationAmount
                }
            ];
        } else {
            requestedProducts = getUpdatedRequestedProducts(
                currentApplicationData,
                {
                    amount: editedApplicationAmount
                }
            );
        }

        yield putAPI({
            type: 'api/PUT_APPLICATION',
            application: JSON.stringify({
                data: { requested_products: requestedProducts }
            })
        });

        yield putAPI({
            type: 'api/GET_APPLICATION'
        });

        GoogleTagManager.trackForm({
            interaction: 'Submit',
            formName: 'Edit loan details modal',
            additionalValue: editedApplicationAmount
        });

        const { hasAutoDecision, activeStep } = yield select((state) => {
            return {
                hasAutoDecision: hasAutomatedDecision(state),
                activeStep: state?.ui?.activeStep?.id
            };
        });

        if (activeStep !== 'businessIntroduction') {
            tracking.ampli.identify(undefined, {
                'Decision type': hasAutoDecision ? 'auto' : 'manual'
            });
        }

        tracking.ampli.identify(undefined, {
            'Requested amount': editedApplicationAmount
        });

        tracking.ampli.requestedAmountChanged({
            edited_amount: editedApplicationAmount,
            ...getAmplitudeDefaultEventProperties()
        });

        yield put({ type: CLOSE_MODAL });
    });
}
